import { render, staticRenderFns } from "./ListChat.vue?vue&type=template&id=b79b8eee&scoped=true&"
import script from "./ListChat.vue?vue&type=script&lang=js&"
export * from "./ListChat.vue?vue&type=script&lang=js&"
import style0 from "./ListChat.vue?vue&type=style&index=0&id=b79b8eee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b79b8eee",
  null
  
)

export default component.exports